import { MakeApiCall } from "../../../../apis";

/**
 * Fetches available product tags for the current marketplace.
 * @param {string} token
 * @returns {Promise<string[]>}
 */
export const fetchProductTags = async (token) => {
    const response = await MakeApiCall("products/tags", "get", null, true, {}, token);
    if (response?.status && Array.isArray(response?.data?.tags)) {
        return response.data.tags;
    }
    return [];
};
